import { Linkedin, Github, Twitter, Mail } from "lucide-react";

const socials = [
  { icon: Linkedin, href: "https://www.linkedin.com/in/udaymanvar/", label: "LinkedIn" },
  { icon: Github, href: "https://github.com/udaymanvar", label: "GitHub" },
  { icon: Twitter, href: "https://x.com/udaymanvar", label: "X" },
  { icon: Mail, href: "mailto:me@udaymanvar.com", label: "Email" },
];

export function Footer() {
  return (
    <footer className="border-t border-border bg-surface/50">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 py-10 sm:flex-row">
        <p className="text-sm text-muted-foreground">
          © 2026 Uday Manvar. Built with passion in Ahmedabad.
        </p>
        <div className="flex items-center gap-2">
          {socials.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              aria-label={s.label}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-border text-muted-foreground transition-smooth hover:border-primary hover:bg-primary/10 hover:text-primary"
            >
              <s.icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
